import Icon from '../components/Icon.vue'

Icon.register({
  'sign-in-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 448H332C325.4 448 320 442.6 320 436V396C320 389.4 325.4 384 332 384H416C433.7 384 448 369.7 448 352V160C448 142.3 433.7 128 416 128H332C325.4 128 320 122.6 320 116V76C320 69.4 325.4 64 332 64H416C469 64 512 107 512 160V352C512 405 469 448 416 448zM369 247L201 79C186 64 160 74.5 160 96V192H24C10.7 192 0 202.7 0 216V312C0 325.3 10.7 336 24 336H160V432C160 453.5 186 464 201 449L369 281C378.3 271.6 378.3 256.4 369 247z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sign-in-alt.js
// module id = NK8H
// module chunks = 144